export enum PaymentType {
    FPX = 1,
    CREDIT_DEBIT_CARD = 2,
    E_WALLET = 3,
}